// extracted by mini-css-extract-plugin
export default {"root":"PhoneNumber_root__Ds68n","wrapper":"PhoneNumber_wrapper__wyH2r","header":"PhoneNumber_header__OviWw","content":"PhoneNumber_content__ocQDL"};